module.exports = __webpack_public_path__ + "static/media/bmp.40fae940.svg";